import { render, staticRenderFns } from "./ItemCyclerItem.vue?vue&type=template&id=051854ca&scoped=true"
import script from "./ItemCyclerItem.vue?vue&type=script&lang=ts"
export * from "./ItemCyclerItem.vue?vue&type=script&lang=ts"
import style0 from "./ItemCyclerItem.vue?vue&type=style&index=0&id=051854ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051854ca",
  null
  
)

export default component.exports